export const oidcStoragePrefix = 'oidc.';

export const defaultAuthRedirectPath = '/auth/callback';
export const defaultPostLogoutRedirectPath = '/auth/logout';
